import { httpClient } from '@/services/http/httpClient'

import type { FinancialDetails } from '@/tabs/shared/financialImpact/types'

export const getFinancialImpactByIdeaId = async (ideaId: string) => {
  const { data } = await httpClient.get<FinancialDetails>(
    `/ideas/financial-details/getByIdeaId/${ideaId}`,
  )

  return data
}
